import { ref } from 'vue'
import i18next from 'i18next'
import { defineStore } from 'pinia'
import type { IChip } from 'www/vue_components/common/TheFilters/lpu/stores/useChipsStore.types'

const chipModel: IChip = {
  name: '',
  order: 0,
  isActive: false,
  isVisible: false,
  dropdown: false,
  truncate: false,
  menuChip: false,
  mapChip: false,
  onClick: () => {},
  onReset: () => {},
}

const useChipsStore = defineStore('chipsStore', () => {
  const menuChip = ref<IChip>({ ...chipModel, menuChip: true, order: 1 })
  const updateMenuChip = (newMenuChip: Partial<IChip>) => {
    menuChip.value = { ...menuChip.value, ...newMenuChip }
  }

  const lpuTypeChip = ref<IChip>({ ...chipModel, order: 2 })
  const updateLpuTypeChip = (newLpuTypeChip: Partial<IChip>) => {
    lpuTypeChip.value = { ...lpuTypeChip.value, ...newLpuTypeChip }
  }

  const doctorSpecialityChip = ref<IChip>({ ...chipModel, order: 3 })
  const updateDoctorSpecialityChip = (newDoctorSpecialityChip: Partial<IChip>) => {
    doctorSpecialityChip.value = { ...doctorSpecialityChip.value, ...newDoctorSpecialityChip }
  }

  const placeChip = ref<IChip>({ ...chipModel, order: 4 })
  const updatePlaceChip = (newPlaceChip: Partial<IChip>) => {
    placeChip.value = { ...placeChip.value, ...newPlaceChip }
  }

  const highRatingChip = ref<IChip>({ ...chipModel, order: 5 })
  const updateHighRatingChip = (newHighRatingChip: Partial<IChip>) => {
    highRatingChip.value = { ...highRatingChip.value, ...newHighRatingChip }
  }

  const workTimeChip = ref<IChip>({ ...chipModel, order: 6 })
  const updateWorkTimeChip = (newWorkTimeChip: Partial<IChip>) => {
    workTimeChip.value = { ...workTimeChip.value, ...newWorkTimeChip }
  }

  const appointmentChip = ref<IChip>({ ...chipModel, order: 7 })
  const updateAppointmentChip = (newAppointmentSwitchChip: Partial<IChip>) => {
    appointmentChip.value = { ...appointmentChip.value, ...newAppointmentSwitchChip }
  }

  const clubSwitchChip = ref<IChip>({ ...chipModel, order: 8 })
  const updateClubSwitchChip = (newClubSwitchChip: Partial<IChip>) => {
    clubSwitchChip.value = { ...clubSwitchChip.value, ...newClubSwitchChip }
  }

  const mapChip = ref<IChip>({
    ...chipModel,
    order: 9,
    name: i18next.t('На карте', { ns: i18next.language }),
    isVisible: true,
    mapChip: true,
  })

  return {
    mapChip,
    menuChip,
    placeChip,
    lpuTypeChip,
    workTimeChip,
    clubSwitchChip,
    highRatingChip,
    appointmentChip,
    doctorSpecialityChip,
    updateMenuChip,
    updatePlaceChip,
    updateLpuTypeChip,
    updateWorkTimeChip,
    updateClubSwitchChip,
    updateHighRatingChip,
    updateAppointmentChip,
    updateDoctorSpecialityChip,
  }
})

export default useChipsStore
